module.exports = __webpack_public_path__ + "img/tour-51.93215ea6.png";